import { useMutation } from "@tanstack/react-query";
import instance from "./axiosInstance";

const ENDPOINT = "/postnummer";

export enum PostnummerQueryKey {
  GuessKommun = "guess-kommun",
}

export type PostnummerLookup = {
  /** 4-digit SCB kommunkod with leading zero, or "" when unknown. */
  kommunKod: string;
  /** Title-cased postort ("Stockholm", "Enskede Gård"), or "" when unknown. */
  postalCity: string;
};

export const useGuessKommun = () =>
  useMutation({
    mutationFn: async ({
      postnummer,
    }: {
      postnummer: string;
    }): Promise<PostnummerLookup> => {
      const response = await instance.post(`${ENDPOINT}/${postnummer}`);
      return {
        kommunKod: response.data?.kommunKod ?? "",
        postalCity: response.data?.postalCity ?? "",
      };
    },
  });
